import { MaxWidthWrapper } from "@/components/maxWidthWrapper";
import { FacialRecognitionCard } from "./facialRecognitionCard";
import { SecurityCard } from "./securityCard";
import { VerificationCard } from "./verificationCard";

export const Points = () => (
  <MaxWidthWrapper className="relative w-full py-12 md:py-16">
    <div className="mx-auto max-w-7xl">
      <div className="text-3xl font-semibold sm:text-4xl md:text-5xl">Use Flash Today</div>
      <div className="py-6 text-lg/8 text-accent-foreground">
        An Overview of Flash’s Verification and Facial Recognition Process
      </div>
      <CardGrid />
    </div>
  </MaxWidthWrapper>
);

const CardGrid = () => (
  <div className="grid grid-cols-1 gap-4 lg:grid-cols-3">
    <div className="space-y-4 lg:col-span-2">
      <FacialRecognitionCard />
      <VerificationCard />
    </div>
    <div className="lg:col-span-1">
      <SecurityCard />
    </div>
  </div>
);
